exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/event-edit/event-edit.component.css
// module id = ../../../../../src/app/components/event-edit/event-edit.component.css
// module chunks = main